import type { LucideIcon } from "lucide-react";
import {
  FileText,
  Send,
  Globe,
  Receipt,
  Users,
  Building2,
  Contact,
  Search,
} from "lucide-react";

export interface DashboardCardData {
  to: string;
  title: string;
  description: string;
  icon: LucideIcon;
  requires?: string;
  public?: boolean;
  adminOnly?: boolean;
}

export const DASHBOARD_CARDS: DashboardCardData[] = [
  {
    to: "/facturas/subir",
    title: "Facturas de Compra",
    description: "Carga, audita y exporta facturas de proveedores nacionales.",
    icon: FileText,
    public: true,
  },
  {
    to: "/ventas/subir",
    title: "Facturas de Ventas",
    description: "Gestiona las facturas emitidas a tus clientes.",
    icon: Send,
    public: true,
  },
  {
    to: "/exterior/subir",
    title: "Facturas Exterior",
    description: "Procesa facturas de proveedores internacionales.",
    icon: Globe,
    public: true,
  },
  {
    to: "/legalizacion/subir",
    title: "Legalización de Gastos",
    description: "Legaliza gastos con detección de anomalías históricas.",
    icon: Receipt,
    public: true,
  },
  {
    to: "/nits",
    title: "NITs",
    description: "Directorio de terceros (clientes y proveedores) con NIT and DV.",
    icon: Contact,
    public: true,
  },
  {
    to: "/confecamaras",
    title: "Consulta de NIT — Confecámaras",
    description:
      "Lotes de hasta 100 NITs contra la base de Confecámaras (datos.gov.co) con cortesía de rate-limit.",
    icon: Search,
    public: true,
  },
  {
    to: "/usuarios",
    title: "Gestión de Usuarios",
    description: "Crea, edita y asigna permisos a usuarios del sistema.",
    icon: Users,
    requires: "ver_usuarios",
  },
  {
    to: "/empresas",
    title: "Gestión de Empresas",
    description: "Administra empresas, sus PUCs y configuración.",
    icon: Building2,
    requires: "ver_empresas",
  },
];
